import { bool, fail, isRecord, list, optionalText, text } from '../../../shared/api/onecEnvelope'
import type { CreateDefaults, CreateField } from '../model/types'

/**
 * Декодер `OneCCreateDefaultsDto` (Resource.OneC.Contracts, RP-SYN11). Поля —
 * по договору `SyncCreateField`; у службы 1С все поля создания — выбор из
 * справочника базы, поэтому поле без вариантов — ошибка ответа, а не пустой
 * список. Ключи ссылок 1С — в нижнем регистре, как их отдаёт служба.
 */
export const CREATE_DEFAULTS_SCHEMA = 'onec.create-defaults.v1'

function field(raw: unknown, index: number): CreateField {
  const item = isRecord(raw) ? raw : fail(`fields[${String(index)}] — не объект`)
  const name = `fields[${String(index)}]`
  if (text(item.type, `${name}.type`) !== 'choice') fail(`${name}: поле создания 1С — только выбор из справочника`)
  const options = list(item.options, `${name}.options`, (entry, position) => {
    const option = isRecord(entry) ? entry : fail(`${name}.options[${String(position)}] — не объект`)
    return { value: text(option.value, `${name}.options.value`), label: text(option.label, `${name}.options.label`) }
  })
  if (options.length === 0) fail(`${name}: нет значений для выбора`)
  return {
    key: text(item.key, `${name}.key`),
    label: text(item.label, `${name}.label`),
    required: bool(item.required, `${name}.required`),
    options,
    defaultValue: optionalText(item.defaultValue, `${name}.defaultValue`),
  }
}

export function decodeCreateDefaults(raw: unknown): CreateDefaults {
  const data = isRecord(raw) ? raw : fail('data — не объект')
  if (text(data.schemaVersion, 'schemaVersion') !== CREATE_DEFAULTS_SCHEMA) fail(`schemaVersion — не ${CREATE_DEFAULTS_SCHEMA}`)
  return {
    fields: list(data.fields, 'fields', field),
    stale: list(data.stale, 'stale', (entry, index) => {
      const item = isRecord(entry) ? entry : fail(`stale[${String(index)}] — не объект`)
      return { key: text(item.key, 'stale.key'), label: text(item.label, 'stale.label') }
    }),
    updatedAt: optionalText(data.updatedAt, 'updatedAt'),
    updatedBy: optionalText(data.updatedBy, 'updatedBy'),
  }
}
